module.exports = __webpack_public_path__ + "static/media/Colette Curve Queen Headboard - 155 cm_White.8f029642.png";